import { formatPhone } from "../../../lib/masks";
import { ROLES } from "./shared";

export function UserEditModal({ busy, editForm, editing, form, setEditForm, setEditing, submitEdit }) {
  return (
    <>
      {/* Edit modal */}
      {editing && editForm && (
        <div className="fixed inset-0 bg-black/60 z-50 grid place-items-center p-4">
          <div className="bg-white rounded-md w-full max-w-lg p-6">
            <div className="flex items-start justify-between gap-4 mb-4">
              <div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500">
                  Editar usuário
                </div>
                <h3 className="mt-1 font-serif-display text-2xl">
                  {editing.name}
                </h3>
              </div>
              <button
                onClick={() => {
                  setEditing(null);
                  setEditForm(null);
                }}
                className="text-slate-500 hover:text-slate-900 text-2xl leading-none"
                aria-label="Fechar"
              >
                ×
              </button>
            </div>
            <form
              data-testid="iu-edit-form"
              onSubmit={submitEdit}
              className="grid grid-cols-2 gap-3"
            >
              <div className="col-span-2">
                <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Nome *
                </label>
                <input
                  data-testid="iu-edit-name"
                  required
                  minLength={2}
                  value={editForm.name}
                  onChange={(e) =>
                    setEditForm({ ...editForm, name: e.target.value })
                  }
                  className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
                />
              </div>
              <div className="col-span-2 md:col-span-1">
                <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  E-mail *
                </label>
                <input
                  data-testid="iu-edit-email"
                  type="email"
                  required
                  value={editForm.email}
                  onChange={(e) =>
                    setEditForm({ ...editForm, email: e.target.value })
                  }
                  className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
                />
              </div>
              <div className="col-span-2 md:col-span-1">
                <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Telefone
                </label>
                <input
                  data-testid="iu-edit-phone"
                  value={editForm.phone}
                  onChange={(e) =>
                    setEditForm({ ...editForm, phone: formatPhone(e.target.value) })
                  }
                  maxLength={15}
                  placeholder="(11) 99999-9999"
                  className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
                />
              </div>
              <div className="col-span-2 md:col-span-1">
                <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Função
                </label>
                <select
                  data-testid="iu-edit-role"
                  value={editForm.role}
                  onChange={(e) =>
                    setEditForm({ ...editForm, role: e.target.value })
                  }
                  className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm bg-white"
                >
                  {ROLES.map((r) => (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-2 md:col-span-1">
                <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Nova senha (opcional)
                </label>
                <input
                  data-testid="iu-edit-password"
                  type="text"
                  minLength={8}
                  value={editForm.password}
                  onChange={(e) =>
                    setEditForm({ ...editForm, password: e.target.value })
                  }
                  className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm font-mono"
                />
              </div>
              <div className="col-span-2 flex gap-2 mt-2">
                <button
                  disabled={busy}
                  data-testid="iu-edit-submit"
                  className="px-5 py-2.5 bg-[#0A0F14] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#002776] disabled:opacity-60"
                >
                  {busy ? "Salvando..." : "Salvar alterações"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setEditing(null);
                    setEditForm(null);
                  }}
                  className="px-5 py-2.5 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
